<script setup>
const ServicesFrameworksContent = defineAsyncComponent(() => import('~/components/molecules/ServicesFrameworksContent.vue'));
definePageMeta({
  layout: "services-layout",
});
</script>

<template>
    <ServicesFrameworksContent />
</template>